import React from 'react';

const CityOption = ({ city, currentCountry }) => {
    if (currentCountry === 0 || currentCountry === city.country) {
        return (
            <option value={city.id} country={city.country}>{city.name}</option>
        )
    }

    return null;
};

export default CityOption;
